// A carrier guide vs. the packing list. The backend persists an order's packing
// list as a VALID Pickup ShippingLabel (PackingListService), so "the order has a
// label" is NOT the same as "the order already has a shipping guide": only
// Shipping / Cash On Delivery labels are real carrier guides. A bare "any label
// exists" check wrongly treats external-guide / warehouse-pickup orders — whose
// only label is the packing list — as already carrying a guide.
//
// A marketplace-fulfilled label is excluded for the same reason. On TikTok Shop, Shopee and
// Anymarket orders the marketplace ships the parcel under its own guide, and the backend
// persists that carrier's tracking number as a VALID Shipping label purely so the dispatch scan
// and the return dock scan can resolve the barcode already printed on the box. It carries no
// label_file, no Cubbo carrier issued it and nobody can regenerate it, so counting it here would
// both gate the guide button on an order that has no Cubbo guide and offer "print shipping
// label" for a PDF that does not exist.
//
// Single source of truth so the several call sites (GenerateShipment gate,
// shipped-orders list) can't drift. Keep CARRIER_LABEL_TYPES in sync with the
// backend enum (ShippingLabel::LABEL_TYPE_SHIPPING / LABEL_TYPE_COD) and keep the
// marketplace_fulfilled exclusion in sync with OrderPolicy#generate_label?, which
// scopes its additional-guide gate the same way.
export const CARRIER_LABEL_TYPES = ['Shipping', 'Cash On Delivery']

// Only an explicit true excludes a label: the flag is absent on payloads from serializers that
// do not expose it, and those must keep behaving exactly as they did before it existed.
export const isMarketplaceFulfilledLabel = label => label?.marketplace_fulfilled === true

export const carrierShippingLabels = (shippingLabels = []) =>
  (shippingLabels || []).filter(label => CARRIER_LABEL_TYPES.includes(label.label_type) && label.status === 'VALID' && !isMarketplaceFulfilledLabel(label))

export const hasCarrierShippingLabel = shippingLabels => carrierShippingLabels(shippingLabels).length > 0
